import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form, Table } from "react-bootstrap";
import {
  generateAdmissionNo,
  getCourseDuration,
  getSalutation,
} from "./utils/letterUtils";

export default function DemandLetter({ student }) {
  const printRef = useRef();

  const [formData, setFormData] = useState({
    refNo: generateAdmissionNo({
      prefix: "RBT",
      course: student?.selectedCourse,
      studentId: student?.studentId,
    }),
    date: new Date().toLocaleDateString(),

    studentName:
      [student?.firstName, student?.middleName, student?.lastName]
        .filter(Boolean)
        .join(" ") || "",

    parentName: student?.fatherName || "",
    address: student?.homeAddress || "",
    course: student?.selectedCourse || "",
    academicYear: student?.academicYear || "",
    duration: getCourseDuration(
      student?.selectedCourse || "",
      student?.academicYear || ""
    ),
    admissionNo: student?.studentId || "",

    year: "I",
    tuitionFees: "150000",
    hostelFees: "75000",
     university: "Rajiv Gandhi University of Health Sciences",
    recognition:
      "KNC Govt. of Karnataka & Indian Nursing Council, New Delhi",

    instituteName: "REHOBOTH INSTITUTE OF NURSING",
    approvalLine:
      "(Recognized by Govt. of Karnataka & Indian Nursing Council)",
    address: "Bangalore, Karnataka",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body { font-family: Roman, serif; padding: 160px 20px 20px; }
            .print-container { line-height: 1.8; }
            .text-center { text-align: center; }
            .text-end { text-align: right; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            td, th { border: 1px solid #000; padding: 8px; text-align: center; }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  const { salute, title, possessive } = getSalutation(student?.gender);

  const total =
    Number(formData.tuitionFees || 0) + Number(formData.hostelFees || 0);

  return (
    <Container className="mt-4">
      {/* FORM */}
      <Form className="mb-4">
        <Row className="mb-2">
          <Col>
            <Form.Control
              name="refNo"
              value={formData.refNo}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <Form.Control
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              name="studentName"
              value={formData.studentName}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <Form.Control
              name="parentName"
              value={formData.parentName}
              onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              name="course"
              value={formData.course}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <Form.Control
              name="academicYear"
              value={formData.academicYear}
              onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Control
              name="duration"
              value={formData.duration}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <Form.Control
              name="admissionNo"
              value={formData.admissionNo}
              onChange={handleChange}
            />
          </Col>
        </Row>

        {/* Fees */}
        <Row className="mb-2">
          <Col>
            <Form.Control
              name="tuitionFees"
              value={formData.tuitionFees}
              onChange={handleChange}
              placeholder="Tuition Fees"
            />
          </Col>
          <Col>
            <Form.Control
              name="hostelFees"
              value={formData.hostelFees}
              onChange={handleChange}
              placeholder="Hostel Fees"
            />
          </Col>
        </Row>
      </Form>

      {/* PRINT BUTTON */}
      <div className="text-end mt-3">
        <Button onClick={handlePrint}>Print</Button>
      </div>

      {/* LETTER */}
      <div
        ref={printRef}
        style={{ padding: 20, border: "1px solid #000" }}
        className="print-container"
      >
        {/* Header */}
        <div style={{marginTop:"100px"}}>
        <Row>
          <Col>
            <strong>{formData.refNo}</strong>
          </Col>
          <Col className="text-end">
            <strong>{formData.date}</strong>
          </Col>
        </Row>

        {/* Title */}
        <Row className="mt-4">
          <Col className="text-center">
            <h2>
              <u>DEMAND LETTER</u>
            </h2>
          </Col>
        </Row>

        {/* Body */}
        <Row className="mt-4">
          <Col>
            <p>
              This is to certify that <strong>{salute} {formData.studentName}</strong>{" "}
              {title} <strong>{formData.parentName}</strong>, residing at{" "}
              <strong>{formData.address}</strong>, is a bonafide student of our
              institution for the academic year{" "}
              <strong>{formData.academicYear}</strong>.
            </p>

            <p>
              The duration of the course is{" "}
              <strong>{formData.duration}</strong>.{" "}
              {possessive} Admission No. is{" "}
              <strong>{formData.admissionNo}</strong>.
            </p>

            <p>
              {salute} {formData.studentName} is currently in the{" "}
              <strong>{formData.year} year</strong> and the fee details are as
              follows:
            </p>

            {/* TABLE */}
            <Table bordered>
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Tuition Fees</th>
                  <th>Hostel Fees</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{formData.year}</td>
                  <td>Rs. {formData.tuitionFees}</td>
                  <td>Rs. {formData.hostelFees}</td>
                </tr>
                <tr>
                  <td colSpan="3">
                    <strong>Total: Rs. {total}</strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
            <Col>
                  <p>
            This institution is affiliated to{" "}
            <strong>{formData.university}</strong> and recognized by{" "}
            <strong>{formData.recognition}</strong>.
          </p>
            </Col>
        </Row>

        {/* Footer */}
        <Row className="mt-5" style={{ paddingTop: "40px" }}>
          <Col className="text-end">
            <p>
              <strong>Principal</strong>
            </p>
          </Col>
        </Row>
        </div>
      </div>
    </Container>
  );
}